module.exports = __webpack_public_path__ + "static/img/profile01.9dc3dec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/mo/profile01.png
// module id = WaPf
// module chunks = 10